import { Box, ColorPicker as ColorPickerBase } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../../../../ricos-context";
import classes from "./custom-color-picker-scss";
const getColorHex = (color) => typeof color === "string" ? color : color.hex();
const CustomColorPicker = ({
  currentColor,
  userColors,
  onColorPreviewStart,
  onColorAdded,
  onBackClick
}) => {
  const { t } = useContext(RicosContext);
  const colorValue = currentColor?.toUpperCase() ?? "";
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      direction: "vertical",
      paddingTop: "SP3",
      paddingLeft: "SP3",
      paddingRight: "SP3",
      paddingBottom: "SP2"
    },
    /* @__PURE__ */ React.createElement(Box, { align: "center", className: classes.customPicker }, /* @__PURE__ */ React.createElement(
      ColorPickerBase,
      {
        allowEmpty: true,
        value: colorValue,
        showConverter: false,
        onChange: (newColor) => {
          const color = getColorHex(newColor);
          onColorPreviewStart?.(color);
        },
        onConfirm: (newColor) => {
          const color = getColorHex(newColor);
          if (!userColors.includes(color)) {
            onColorAdded(color);
          }
          onBackClick();
        },
        onCancel: onBackClick,
        emptyPlaceholder: t("CustomColorPicker_Empty_Placeholder")
      }
    ))
  );
};
export {
  CustomColorPicker
};
//# sourceMappingURL=custom-color-picker.js.map
